// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import Modal from '@material-ui/core/Modal';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

const MyModal = ({
  classes,
  open,
  handleClose,
  children,
}) => {
  return (
    <Modal
      aria-labelledby={'modal-title'}
      aria-describedby={'modal-description'}
      open={open}
      onClose={handleClose}
      className={classes.mainContainer}
    >
      {children}
    </Modal>);
};

MyModal.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  children: PropTypes.any,
};

MyModal.defaultProps = {
  classes: {},
  open: false,
  handleClose: () => { },
  children: null,
};

export default withStyles(styles)(MyModal);
